import { render, staticRenderFns } from "./MethodPaidInfo.vue?vue&type=template&id=5437dda6&scoped=true&"
import script from "./MethodPaidInfo.vue?vue&type=script&lang=js&"
export * from "./MethodPaidInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437dda6",
  null
  
)

export default component.exports